export const SITE = {
  name: "RankCollections",
  domain: "https://rankcollections.com",
  appInstallUrl: "https://apps.shopify.com/rank-collections",
  appDomain: "https://app.rankcollections.com",
  tagline: "AI-Powered Merchandising for Shopify",
  description:
    "Stop losing sales to stale collections. RankCollections uses AI to automatically manage your Shopify product collections.",
  trustBadges: [
    "No credit card required",
    "2-minute setup",
    "Built for Shopify",
  ],

  // ===== WAITLIST / FOUNDING MEMBER MODE =====
  // Single source of truth: derived from the LANDING_MODE flag (server env on
  // SSR, window.ENV.LANDING_MODE on the client). Default is "live" — set
  // LANDING_MODE=waitlist to restore founding-member / waitlist CTAs and the
  // founding-pricing block. This keeps the install form, persona CTA copy, and
  // the home founding-pricing section consistent.
  waitlistMode:
    (typeof window !== "undefined"
      ? (window as unknown as { ENV?: { LANDING_MODE?: string } }).ENV?.LANDING_MODE
      : process.env.LANDING_MODE) === "waitlist",
  // Client: window.ENV.CORE_API_URL is the PUBLIC app origin (set from
  // PUBLIC_CORE_API_URL in prod; empty in dev → localhost fallback). Server:
  // process.env.CORE_API_URL is the internal docker URL (http://api:8000).
  // Matches the admin components' pattern (SitemapSection/CaseStudies).
  coreApiUrl:
    (typeof window !== "undefined"
      ? (window as unknown as { ENV?: { CORE_API_URL?: string } }).ENV?.CORE_API_URL
      : process.env.CORE_API_URL) || "http://localhost:8000",
  foundingMember: {
    totalSpots: 50,
    proPrice: "$14.50/mo",
    proPriceOriginal: "$29/mo",
    growthPrice: "$49.50/mo",
    growthPriceOriginal: "$99/mo",
    discount: "50%",
    ctaText: "Claim Your Founding Spot",
    ctaTextShort: "Join Waitlist",
  },
  waitlistTrustBadges: [
    "50% off forever",
    "Only 50 spots",
    "No credit card now",
  ],
  aso: {
    showRating: false,
  },
} as const;
